import cx from 'classnames';
import React from 'react';

import { IconButton, InputAdornment, TextField, TextFieldProps } from '@material-ui/core';
import Clear from '@material-ui/icons/Clear';

import styles from './ClearableTextField.module.scss';

export type ClearableTextFieldProps = TextFieldProps & {
  hasClear?: boolean;
  onClear?: () => void;
};

const ClearableTextField = ({
  hasClear,
  onClear = () => null,
  value,
  InputProps = {},
  className,
  ...rest
}: ClearableTextFieldProps) => (
  <TextField
    value={value}
    InputProps={{
      endAdornment:
        hasClear && value ? (
          <InputAdornment position={'end'}>
            <IconButton
              aria-label={'clear'}
              onClick={onClear}
              onMouseDown={e => e.preventDefault()}
              edge={'end'}
              size={'small'}
              className={styles.textFieldClearButton}
            >
              <Clear fontSize={'small'} />
            </IconButton>
          </InputAdornment>
        ) : null,
      ...InputProps,
    }}
    className={cx(styles.textField, className)}
    {...rest}
  />
);

export default ClearableTextField;
